import { makeStyles } from '@material-ui/core';
import React from 'react';
import { CalendarEvent } from '../../global';
import { Event } from '../../global/calendar/Event';
import { ProjectCalendar } from '../common/ProjectCalendar';

const useCalendarViewClasses = makeStyles({
    root: {
        display: 'flex',
        flex: '1 0 calc(100vh - 200px)',
        gap: 16,
    },
    cards: {
        display: 'flex',
        flexDirection: 'column',
        width: 260,
        '& > div': {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            '@supports (overflow: overlay)': { overflow: 'overlay' },
            flex: '1 0 0',
            gap: 4,
        },
    },
    calendar: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 400,
    },
});

export const ProjectListCalendarView = (props: { showCards: boolean }) => {
    const classes = useCalendarViewClasses();
    const [events, setEvents] = React.useState<CalendarEvent[]>([]);

    return (
        <div className={classes.root}>
            <div className={classes.cards}>
                <div>
                    {events.map((e, i) => (
                        <Event event={e} view='year' tooltip />
                    ))}
                </div>
            </div>
            <div className={classes.calendar}>
                <ProjectCalendar onFilter={setEvents} />
            </div>
        </div>
    );
};
